module.exports = __webpack_public_path__ + "static/media/icon-event-time.0a7edf26.svg";